import { DayShapeType } from '@app/entities/interfaces/anual-calendar/day.interface';

export class LababsVacations {
  months!: AnualCalendarMonth[];
  captions!: AnualCalendarCaptionDay[];
  totals!: AnualCalendarTotals[];
  year!: string;
}

export class AnualCalendarDay {
  date!: string;
  dayLabel!: string;
  dayType!: AnualCalendarDayType | null;
  selected?: boolean;
}

export class AnualCalendarDayType {
  ids!: string[];
  name!: string;
  primaryColour!: string;
  primaryShape!: string;
  secondaryColour!: string;
  secondaryShape!: string;
  isWorkingDay!: boolean;
}

export class AnualCalendarWeek {
  days!: AnualCalendarDay[];
}

export class AnualCalendarMonth {
  yearLabel!: string;
  monthLabel!: string;
  weeks!: AnualCalendarWeek[];
}

export class AnualCalendarCaptionDay {
  id!: string;
  name!: string;
  colour!: string;
  order!: number;
  shape!: DayShapeType;
}

export class AnualCalendarTotals {
  dayType!: AnualCalendarCaptionDay;
  total!: number;
}

export class VacationsYear {
  year!: number;
}
